import React from "react";
import MasonryGallery from "../components/MasonryGallery";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const CustomCursor = () => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            if (e.target.closest("button, a, .cursor-hover")) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseover", handleMouseOver);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);

    return (
        <div
            className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            <div
                className={`rounded-full bg-white transition-all duration-300 ease-out ${isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
                    }`}
            />
        </div>
    );
};

const VyshnaviAniGallery = () => {
    const images = [
        "/assets/wedding/vyshanavie_anirudh_webp/w1.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w2.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w3.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w4.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w5.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w6.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w7.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w8.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w9.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w10.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w11.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w12.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w13.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w14.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w15.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w16.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w17.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w18.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w19.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w20.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w21.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w22.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w23.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w24.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w25.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w26.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w27.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w28.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w29.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w30.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w31.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w32.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w33.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w34.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w35.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w36.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w37.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w38.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w39.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w40.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w41.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w42.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w43.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w44.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w45.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w46.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w47.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w48.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w49.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w50.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w51.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w52.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w53.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w54.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w55.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w56.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w57.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w58.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w59.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w60.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w61.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w62.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w63.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w64.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w65.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w66.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w67.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w68.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w69.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w70.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w71.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w72.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w73.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w74.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w75.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w76.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w77.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w78.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w79.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w80.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w81.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w82.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w83.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w84.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w85.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w86.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w87.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w88.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w89.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w90.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w91.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w92.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w93.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w94.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w95.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w96.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w97.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w98.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w99.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w100.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w101.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w102.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w103.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w104.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w105.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w106.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w107.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w108.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w109.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w110.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w111.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w112.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w113.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w114.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w115.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w116.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w117.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w118.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w119.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w120.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w121.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w122.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w123.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w124.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w125.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w126.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w127.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w129.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w130.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w131.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w132.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w133.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w134.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w135.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w136.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w137.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w138.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w139.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w140.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w141.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w142.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w143.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w144.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w145.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w146.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w147.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w148.webp",
        "/assets/wedding/vyshanavie_anirudh_webp/w149.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w150.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w151.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w152.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w153.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/wedding/vyshanavie_anirudh_webp/w154.webp",
    ];

    return (
        <div className="bg-neutral-950 min-h-screen" style={{ cursor: "none" }}>
            <CustomCursor />
            <Navigation />
            <MasonryGallery
                title="Vyshanavie & Anirudh"
                subtitle="TUSCANY, ITALY — DESTINATION WEDDING"
                images={images}
            />

            <Footer />
        </div>
    );
};

export default VyshnaviAniGallery;
